import { Component, OnInit, NgModule } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { startWith } from 'rxjs/operators/startWith';
import Swal from 'sweetalert2';
import { ApiService } from '../../services/api.service';
import { Global } from '../../global';

import {
  Router,
  NavigationStart,
  NavigationEnd,
  ActivatedRoute,
  Event as NavigationEvent
} from "@angular/router";

@Component({
  selector: 'app-recupera-senha',
  templateUrl: './recupera-senha.component.html',
  styleUrls: ['./recupera-senha.component.css']
})
export class RecuperaSenhaComponent implements OnInit {

  campo2: boolean = false;
  campo3: boolean = false;


  usuarioId: any;
  login: any = {};
  auth: any = {};
  User: any = {};
  desativar_botao: any = false;
  passo: any = 1;
  loading: any = false;
  cpf_valido: any = false;
  currentUser: any;
  listaEmpresas: any = [];

  returnUrl: string;
  passo2: boolean = false;
  recupera: any = {};

  constructor(
    private apiService: ApiService,
    public router: Router,
    public route: ActivatedRoute,
    public global: Global
  ) {
    //this.usuarioId = data.usuario_id;
  }

  ngOnInit() {
  }

  etapa1() {
    if (this.recupera.cpf == null || this.recupera.cpf == "") {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'CPF Inválido!'
      });
      this.loading = false;
      this.passo = 1;
      return false;
    }
    else {
      this.loading = true;
      this.login.login = this.recupera.cpf.replace(/\D+/g, '');
      this.apiService.Post("Auths/Etapa1?cpf_usuario=" + this.login.login, null)
        .then(
          result => {
            this.listaEmpresas = result;
            if (this.listaEmpresas != null && this.listaEmpresas != [] && this.listaEmpresas.length != null && this.listaEmpresas.length > 0) {
              this.passo = 2;
            }
            else {
              Swal.fire({
                type: 'error',
                title: 'Oops...',
                text: 'Login inválido'
              });
              this.passo = 1;
              this.campo2 = false;
            }
            this.loading = false;
            return;
          },
          err => {
            this.loading = false;
            this.login.senha = "";
            if (err.status == 401) {
              this.router.navigate(["/login"]);
              return;
            }
            Swal.fire({
              type: 'error',
              title: 'Oops...',
              text: err.error.mensagem
            });
          }
        );
      this.campo2 = true;
    }
    this.campo2 = true;
  }
  etapa2() {
    this.campo3 = true;
  }

  valido() {
    return new Promise((resolve, reject) => {
      console.log(this.recupera)
      if (this.recupera.cpf == null || this.recupera.cpf == "") {
        reject('Informe o CPF')
      }
      if (this.recupera.cliente_uuid == null || this.recupera.cliente_uuid == "") {
        reject('Informe o Cliente')
      }
      if (this.recupera.email == null || this.recupera.email == "") {
        reject('Informe o E-mail')
      }
      resolve("validação realizada");
    })
    
  }

  disparaMail() {
    this.loading = true;
    this.valido().then(
      result => {        
      this.apiService.Post("Auths/RecuperarSenha", this.recupera).then(
        result => {
          Swal.fire({
            type: 'success',
            title: 'Oops... Vimos que alguém aí esqueceu a senha',
            text: 'Para garantir que você possa manter seu acesso ao sistema, um link foi enviado para o seu endereço de e-mail para que possa executar, de fato, a recuperação de sua senha'
          });
          this.router.navigate(['/login']);
        },
        err => {
          if (err.status == 401) {
            this.router.navigate(["/login"]);
            this.loading = false;
            return;
          }
          this.loading = false;
          Swal.fire({
            type: 'error',
            title: 'Oops...',
            text: err.error.mensagem
          });
        }
      );
      },
      error => {
        this.loading = false;
          Swal.fire({
            type: 'error',
            title: 'Oops...',
            text: error
          });
      }
    )
  }
  

}



// WEBPACK FOOTER //
// ./src/app/pages/recupera-senha/recupera-senha.component.ts